import styled from 'styled-components';
import { CrudStyles } from '../shared/Crud';

const { Button: CrudButton } = CrudStyles;

export const MOBILE_BREAKPOINT = '768px';

export const AddToMapButton = styled(CrudButton).attrs({ type: 'button', variant: 'outline' })`
    font-size: 12px;
    padding: 6px 10px;
    white-space: nowrap;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        width: 100%;
        justify-content: center;
        min-height: 44px;
        font-size: 13px;
        padding: 10px 14px;
    }
`;

export const PageWrap = styled.div`
    padding: clamp(16px, 3vw, 32px);
    min-width: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 12px 12px 20px;
    }
`;

export const IntroText = styled.p`
    margin: 0;
    font-size: 13px;
    line-height: 1.45;
    color: ${({ theme }) => theme.colors?.gray?.[600] || '#6b7280'};

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        font-size: 12px;
        line-height: 1.5;
    }
`;

export const TwoColumnGrid = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: clamp(16px, 2vw, 24px);
    align-items: stretch;
    min-height: min(70vh, 720px);

    @media (max-width: 960px) {
        grid-template-columns: 1fr;
        min-height: 0;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        gap: 12px;

        & > *:first-child {
            max-height: min(52vh, 420px);
        }
    }
`;

/** Barra de ações abaixo da composição da rota (ex.: confirmar roteiro). */
export const RouteFooterActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 8px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;

        button {
            width: 100%;
            justify-content: center;
            min-height: 44px;
        }
    }
`;

export const Panel = styled.div`
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
`;

export const PanelHeader = styled.div`
    padding: 14px 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors?.gray?.[100] || '#eee'};
    font-weight: 600;
    font-size: 15px;
    color: ${({ theme }) => theme.colors?.gray?.[900] || '#222'};

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 12px 14px;
        font-size: 14px;
    }
`;

export const PanelBody = styled.div`
    flex: 1;
    min-height: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
`;

export const ListHeaderRow = styled.div`
    display: grid;
    grid-template-columns: minmax(10rem, auto) 72px minmax(0, 1fr) auto;
    gap: 8px;
    align-items: center;
    padding: 10px 16px;
    background: ${({ theme }) => theme.colors?.background || '#f5f5f5'};
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.gray?.[700] || '#555'};
    border-bottom: 1px solid ${({ theme }) => theme.colors?.gray?.[100] || '#eee'};
    text-transform: uppercase;
    letter-spacing: 0.03em;

    & > :nth-child(4) {
        justify-self: end;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        display: none;
    }
`;

export const DeliveryRow = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.colors?.gray?.[100] || '#eee'};

    &:last-child {
        border-bottom: none;
    }
`;

export const RowTop = styled.div`
    display: grid;
    grid-template-columns: minmax(10rem, auto) 1fr;
    align-items: center;
    padding: 0 16px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        grid-template-columns: 1fr;
        padding: 0;
        gap: 0;
    }
`;

export const ListRowActionCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 0;
    min-width: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 12px 16px 4px;
    }
`;

/** Área à direita do botão: ID + cliente (botão) e status. */
export const RowRight = styled.div`
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr) auto;
    align-items: center;
    gap: 8px;
    min-width: 0;
    padding: 12px 0 12px 8px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        grid-template-columns: minmax(0, 1fr) auto;
        padding: 4px 16px 12px;
        gap: 10px;
    }
`;

export const StatusCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 0;
    flex-shrink: 0;
`;

export const CheckboxWrap = styled.label`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    cursor: pointer;
    margin: 0;

    input {
        width: 18px;
        height: 18px;
        cursor: pointer;
    }
`;

export const RowToggle = styled.button`
    grid-column: 1 / 3;
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 8px;
    align-items: center;
    width: 100%;
    min-width: 0;
    padding: 0;
    text-align: left;

    background: ${({ $active, theme }) =>
        $active ? (theme?.colors?.primary?.light ? `${theme.colors.primary.light}14` : 'rgba(94, 129, 172, 0.1)') : 'transparent'};
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: ${({ theme }) => theme.colors?.gray?.[900] || '#222'};
    transition: background 0.15s;

    &:hover {
        background: ${({ theme }) =>
            theme?.colors?.primary?.light ? `${theme.colors.primary.light}12` : 'rgba(94, 129, 172, 0.08)'};
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        grid-column: auto;
        grid-template-columns: auto minmax(0, 1fr);
        min-height: 44px;
        padding: 4px 0;
    }
`;

export const IdCell = styled.span`
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: ${({ theme }) => theme.colors?.primary?.main || '#3b5998'};
`;

export const CustomerCell = styled.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ExpandedDetail = styled.div`
    padding: 14px 16px 18px clamp(56px, 10vw, 96px);
    background: ${({ theme }) => theme.colors?.gray?.[50] || '#fafafa'};
    font-size: 14px;
    color: ${({ theme }) => theme.colors?.gray?.[700] || '#555'};
    line-height: 1.5;
    word-break: break-word;
    display: grid;
    gap: 8px;

    strong {
        color: ${({ theme }) => theme.colors?.gray?.[900] || '#222'};
        margin-right: 6px;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 12px 16px 16px;
        font-size: 13px;
    }
`;

/** Fundo estilo mapa (paleta próxima ao Google Maps) em camada desfocada; conteúdo permanece nítido. */
export const MapPanelBody = styled(PanelBody)`
    padding: 20px;
    position: relative;
    isolation: isolate;
    /* Janela fixa dos pontos do roteiro: rolagem sempre contida neste bloco. */
    height: clamp(420px, 62vh, 560px);
    min-height: clamp(420px, 62vh, 560px);
    max-height: clamp(420px, 62vh, 560px);
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior-y: contain;
    overscroll-behavior-x: none;
    /* Cor de terra “default” do mapa, visível nas bordas do desfoque */
    background: #e5e3df;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        z-index: 0;
        pointer-events: none;
        /* Desfoque + leve escala para esconder bordas do blur */
        filter: blur(11px);
        transform: scale(1.07);
        transform-origin: center center;
        background:
            /* massas d’água (azul característico) */
            radial-gradient(ellipse 92% 58% at 6% 76%, #9ecae8 0%, transparent 58%),
            radial-gradient(ellipse 78% 52% at 94% 16%, #8ec4dc 0%, transparent 54%),
            radial-gradient(ellipse 55% 48% at 78% 90%, #7eb8d4 0%, transparent 50%),
            radial-gradient(ellipse 40% 36% at 52% 12%, #a8d4ea 0%, transparent 55%),
            /* áreas verdes (parques / vegetação) */
            radial-gradient(ellipse 38% 30% at 26% 36%, #b5dcb5 0%, transparent 62%),
            radial-gradient(ellipse 34% 28% at 60% 50%, #a5d4a5 0%, transparent 58%),
            radial-gradient(ellipse 30% 24% at 44% 74%, #c8e8c4 0%, transparent 52%),
            /* base terrestre (bege acinzentado) */
            linear-gradient(168deg, #ebe9e4 0%, #e5e3df 38%, #dad7d0 100%),
            /* sugestão de malha viária (claro sobre terreno) */
            repeating-linear-gradient(
                118deg,
                transparent,
                transparent 34px,
                rgba(255, 255, 255, 0.52) 34px,
                rgba(255, 255, 255, 0.52) 36px
            ),
            repeating-linear-gradient(
                32deg,
                transparent,
                transparent 46px,
                rgba(210, 208, 202, 0.5) 46px,
                rgba(210, 208, 202, 0.5) 47px
            );
    }

    & > * {
        position: relative;
        z-index: 1;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        height: clamp(260px, 42vh, 400px);
        min-height: clamp(260px, 42vh, 400px);
        max-height: clamp(260px, 42vh, 400px);
        padding: 12px;
    }
`;

export const MapEmpty = styled.p`
    margin: 0;
    text-align: center;
    color: ${({ theme }) => theme.colors?.gray?.[800] || '#1f2937'};
    font-size: 14px;
    padding: 32px 16px;
    font-weight: 500;
    text-shadow: 0 0 12px rgba(255, 255, 255, 0.85), 0 1px 2px rgba(255, 255, 255, 0.9);
`;

export const RouteStopsColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    max-width: min(100%, 480px);
    margin: 0 auto;
`;

/** Invólucro para animação FLIP ao reordenar paradas (Subir/Descer). */
export const StopMotionWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const StopCard = styled.div`
    display: flex;
    gap: 12px;
    align-items: flex-start;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 10px;
    padding: 12px 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid ${({ theme }) => theme.colors?.gray?.[100] || '#eee'};

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 12px;
        gap: 10px;
    }
`;

export const StopOrderBadge = styled.div`
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 14px;
    color: #fff;
    background: ${({ theme }) => theme?.colors?.primary?.main || '#3b5998'};
`;

export const StopCardBody = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StopTitle = styled.div`
    font-weight: 600;
    font-size: 14px;
    color: ${({ theme }) => theme.colors?.gray?.[900] || '#222'};
`;

/** Título principal do ponto na tela de detalhes (ação: COLETA, ENTREGA…). */
export const StopPointActionTitle = styled.div`
    font-weight: 700;
    font-size: 15px;
    letter-spacing: 0.02em;
    color: ${({ theme }) => theme.colors?.gray?.[900] || '#111'};
`;

/** Sub-destaque: endereço do ponto na tela de detalhes. */
export const StopPointAddress = styled.div`
    font-weight: 500;
    font-size: 13px;
    line-height: 1.45;
    color: ${({ theme }) => theme.colors?.gray?.[800] || '#374151'};
`;

export const StopPointHeader = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    justify-content: space-between;
`;

export const StopMeta = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.colors?.gray?.[600] || '#6b7280'};
`;

/** Ação do ponto (enum RoutePointAction) — área do dropdown. */
export const StopActionFieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid
        ${({ theme }) =>
            theme?.colors?.primary?.light ? `${theme.colors.primary.light}55` : 'rgba(59, 130, 246, 0.28)'};
    background: ${({ theme }) =>
        theme?.colors?.primary?.light ? `${theme.colors.primary.light}10` : 'rgba(59, 130, 246, 0.06)'};
`;

export const StopActionLabel = styled.label`
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: ${({ theme }) => theme.colors?.gray?.[600] || '#6b7280'};
`;

export const StopPointActionSelect = styled.select`
    width: 100%;
    min-width: 0;
    padding: 10px 12px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.colors?.gray?.[200] || '#e5e7eb'};
    background: #fff;
    color: ${({ theme }) => theme.colors?.gray?.[900] || '#111'};
    cursor: pointer;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme?.colors?.primary?.main || '#3b5998'};
        box-shadow: 0 0 0 2px
            ${({ theme }) => (theme?.colors?.primary?.main ? `${theme.colors.primary.main}40` : 'rgba(59, 130, 246, 0.25)')};
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        min-height: 44px;
        font-size: 16px;
    }
`;

export const StopActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        gap: 8px;

        button {
            flex: 1 1 calc(50% - 4px);
            justify-content: center;
            min-height: 40px;
            min-width: 0;
        }

        button:last-child {
            flex: 1 1 100%;
        }
    }
`;

export const StopDescriptionSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
`;

export const StopDescriptionHint = styled.span`
    font-size: 11px;
    color: ${({ theme }) => theme.colors?.gray?.[600] || '#6b7280'};
    line-height: 1.35;
`;

export const StopDescriptionTextarea = styled.textarea`
    width: 100%;
    min-width: 0;
    min-height: 72px;
    max-height: 160px;
    padding: 8px 10px;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.colors?.gray?.[200] || '#e5e7eb'};
    font-size: 13px;
    font-family: inherit;
    line-height: 1.4;
    resize: vertical;
    color: ${({ theme }) => theme.colors?.gray?.[900] || '#222'};
    background: #fff;

    &:focus {
        border-color: ${({ theme }) => theme?.colors?.primary?.main || '#3b5998'};
        outline: none;
    }

    &::placeholder {
        color: ${({ theme }) => theme.colors?.gray?.[400] || '#9ca3af'};
    }
`;

export const StopSecondaryActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        button {
            width: 100%;
            justify-content: center;
            min-height: 40px;
        }
    }
`;

export const ConnectorLine = styled.div`
    width: 2px;
    height: 16px;
    margin-left: 27px;
    background: ${({ theme }) => theme?.colors?.primary?.main || '#3b5998'};
    opacity: 0.45;
    flex-shrink: 0;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        margin-left: 23px;
    }
`;

export const DesktopOnly = styled.div`
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        display: none;
    }
`;

export const MobileOnly = styled.div`
    display: none;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        display: block;
    }
`;

export const DetailHeaderMeta = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px 16px;
    align-items: center;
    margin-top: 8px;
    font-size: 14px;
    color: #64748b;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        font-size: 13px;
    }
`;

export const DetailHeaderActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    flex: 1 1 100%;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;

        button {
            width: 100%;
            justify-content: center;
            min-height: 44px;
        }
    }
`;

export const DetailHeaderActionsGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;

    &:last-child {
        margin-left: auto;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        width: 100%;
        flex-direction: column;
        margin-left: 0 !important;
    }
`;

export const DetailErrorBanner = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
    padding: 14px 16px;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 10px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;

        button {
            width: 100%;
            justify-content: center;
        }
    }
`;

export const RoutePointStatusMappingBox = styled.div`
    margin: 0 0 16px;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid #bfdbfe;
    background: #eff6ff;
    font-size: 12px;
    line-height: 1.45;
    color: #374151;

    strong {
        font-weight: 600;
    }

    ul {
        margin: 8px 0 0;
        padding-left: 18px;
    }

    li {
        margin-bottom: 6px;
    }

    li:last-child {
        margin-bottom: 0;
    }
`;

export const StopPointActionDeliveryHint = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: ${({ theme }) => theme.colors?.gray?.[600] || '#6b7280'};
    line-height: 1.4;
`;

export const RouteListCard = styled.article`
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const RouteListCardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    min-width: 0;
`;

export const RouteListCardTitle = styled.div`
    min-width: 0;
    flex: 1;

    strong {
        display: block;
        font-size: 15px;
        color: ${({ theme }) => theme.colors?.gray?.[900] || '#111'};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    span {
        font-size: 12px;
        color: ${({ theme }) => theme.colors?.gray?.[600] || '#6b7280'};
    }
`;

export const RouteListCardMeta = styled.div`
    display: grid;
    gap: 6px;
    font-size: 13px;
    color: ${({ theme }) => theme.colors?.gray?.[700] || '#374151'};
`;

export const RouteListCardRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
`;

export const RouteListCardActions = styled.div`
    display: flex;
    padding-top: 4px;

    button {
        width: 100%;
        justify-content: center;
        min-height: 44px;
        margin: 0;
        border: 1px solid ${({ theme }) => theme.colors?.gray?.[200] || '#e5e7eb'};
        border-radius: 6px;
        font-size: 14px;
    }
`;

export const RouteListCards = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
